export default __webpack_public_path__ + "static/media/play-circle.e42cf0cc.svg";